import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { TdspCreateConversionPixelComponent } from "./tdsp-create-conversion-pixel/tdsp-create-conversion-pixel.component";
import { TdspEditConversionPixelComponent } from "./tdsp-edit-conversion-pixel/tdsp-edit-conversion-pixel.component";
import { TdspConversionPixelLandingComponent } from "./tdsp-conversion-pixel-landing/tdsp-conversion-pixel-landing.component";

const routes: Routes = [
  { path: "", component: TdspConversionPixelLandingComponent },
  { path: "create", component: TdspCreateConversionPixelComponent },
  { path: ":id/edit", component: TdspEditConversionPixelComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class TdspConversionPixelRoutingModule {}
